export const getShareCommissionPercent = (product) => Number(product?.percentComissionByShare) || 0;

// Só o plano Promoter recebe a comissão; o vendedor não ganha nada compartilhando o próprio produto.
export const canEarnShareCommission = (userType, product) =>
  userType === "Promoter" &&
  getShareCommissionPercent(product) > 0 &&
  !!localStorage.getItem("__extraconomy_username") &&
  localStorage.getItem("__extraconomy_username") !== product?.user?.username;

export const formatPercent = (value) =>
  Number(value).toLocaleString(undefined, { maximumFractionDigits: 2 });

export const buildShareLink = (productId, shareToken) =>
  `${window.location.origin}/product/${productId}?share=${encodeURIComponent(shareToken)}`;
